module.exports = __webpack_public_path__ + "img/horizontal_6_3_pp3_8017.c2ea26ab.png";